export { default as Sidebar } from '@components/sidebar/Sidebar';



// WEBPACK FOOTER //
// ./src/components/sidebar/index.ts